import React from 'react';
import classnames from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ReactComponent as FacebookIcon } from 'images/icon/facebook_share.svg';
import { ReactComponent as LineIcon } from 'images/icon/line_share.svg';
import { ReactComponent as LinkIcon } from 'images/icon/link_share.svg';
import { FacebookShareButton } from 'react-share';
import styles from './index.module.scss';

interface IShareLink {
    className?: string;
    setCopied: (bool: boolean) => void;
    isPreview: boolean;
}

const ShareLink: React.FC<IShareLink> = ({
    setCopied, className, isPreview
}): JSX.Element => {
    const linkIcon = (key: string) => {
        let icon = null;
        switch (key) {
            case 'facebook':
                icon = <FacebookIcon />;
                break;
            case 'line':
                icon = <LineIcon />;
                break;
            case 'link':
                icon = <LinkIcon />;
                break;
            default:
                icon = null;
        }
        return <div className={classnames(styles[key], styles.linkIcon)}>{icon}</div>;
    };

    const onClickLineShareButton = () => {
        const currentUrl = encodeURIComponent(window.location.href);
        window.open(
            `https://social-plugins.line.me/lineit/share?url=${currentUrl}`,
            '_blank',
            'toolbar=0,location=0,menubar=50,height=500,width=500'
        );
    };

    return (
        <div className={classnames(className, styles.shareContainer)}>
            <span>Share</span>
            <hr />
            <div className={styles.linkContainer}>
                {isPreview ? linkIcon('facebook') : (
                    <FacebookShareButton url={window.location.href} title="網站分享至Facebook(另開視窗)">
                        {linkIcon('facebook')}
                    </FacebookShareButton>
                )}
                {isPreview ? linkIcon('line') : (
                    <button
                        title="網站分享至Line(另開視窗)"
                        type="button"
                        onClick={onClickLineShareButton}
                    >
                        {linkIcon('line')}
                    </button>
                )}
                <CopyToClipboard onCopy={() => setCopied(true)} text={window.location.href}>
                    <button
                        type="button"
                        title="複製網頁連結"
                    >
                        {linkIcon('link')}
                    </button>
                </CopyToClipboard>
            </div>
        </div>
    );
};

ShareLink.defaultProps = {
    className: ''
};

export default ShareLink;
